/**
 * Temporary kill-switch for GFA (Grundfahraufgaben) task-group management: creating new groups,
 * reassigning a group's license classes, and archiving/deleting a group. Task-level editing within
 * an existing group (rename, enable/disable, add/remove/reorder tasks) is unaffected.
 * Flip back to true to restore these actions; UI/logic behind them is left intact.
 */
export const GFA_GROUP_MANAGEMENT_ENABLED = false;
